import ComponentVariantCard from './ComponentVariantCard';
export default ComponentVariantCard;
